import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function Caption({ className = '', children = null }) {
  if (!children) return null;

  return <small className={cn(styles.container, className)}>{children}</small>;
}
